<template>
  <div>
    <v-alert color="warning" class="rounded-card" outlined dismissible>
      <span>NÃO COBRAMOS COMISSÕES EM COTAÇÕES!</span>
    </v-alert>
  </div>
</template>

<script>
export default {
};
</script>
